import * as React from 'react'

import * as api from '@owl-nest/api-client/latest'
import * as model from '@owl-nest/models'
import { Tag } from '@ulule/owl-kit-components/next'
import { MoneyDisplayer } from '@owl-nest/money'

type SponsorshipTag = {
  sponsorship: api.Sponsorship
  project: api.Project
}

export function SponsorshipTag({ sponsorship, project }: SponsorshipTag): React.ReactElement<SponsorshipTag> | null {
  const tag = model.sponsorship.tag(sponsorship)

  if (tag === undefined) {
    return null
  }

  if (tag.type === api.SponsorshipType.AMOUNT) {
    return (
      <Tag color="sand">
        <span role="img" aria-label="prize emoji">
          {tag.icon}
        </span>
        + <MoneyDisplayer amount={tag.amount} project={project} />
      </Tag>
    )
  }

  return (
    <Tag color="sand">
      <span role="img" aria-label="prize emoji">
        {tag.icon}
      </span>
      {tag.label}
    </Tag>
  )
}
